import { useMediaQuery } from "@mui/material";

const useCustomMediaQuery = (mediaQueryString) => {
  return useMediaQuery(mediaQueryString);
};

export default useCustomMediaQuery;
